import React, { useState, useEffect } from 'react';
import swal from 'sweetalert2';
import { TextField, Button } from '@material-ui/core';
import { TrackAppFeedback } from 'utilities/insights';
import animate from 'utilities/animate';
import { useDispatch, useSelector } from 'react-redux';
import { sendAppFeedback, sendContactRequest } from 'redux/thunks/feedback';
import { resetSendingAppFeedback, resetSendingContactRequest } from 'redux/actions/feedback';
import { Grid } from '@material-ui/core';

const Form = ({ type }) => {
    const email = useSelector((state) => state.user.email);
    const userName = useSelector((state) => state.user.userName);
    const authenticated = useSelector((state) => state.user.authenticated);
    const feedback = useSelector((state) => state.feedback);
    const [typeDisp, set_typeDisp] = useState(type);
    const [subject, set_subject] = useState('');
    const [name, set_name] = useState('');
    const [formEmail, set_formEmail] = useState('');
    const [disabled, set_disabled] = useState(false);
    const [message, set_message] = useState('');
    const dispatch = useDispatch();

    const [textOpacity, set_textOpacity] = useState(1);

    const handleSubmit = async (event) => {
        const content = {
            subject,
            name,
            email: formEmail,
            message,
            type,
        };

        if (typeDisp === 'contact') {
            dispatch(sendContactRequest(content));
        } else {
            dispatch(sendAppFeedback(content));
        }
        TrackAppFeedback();
    };

    const resetForm = () => {
        set_message('');
        set_subject('');
    };

    useEffect(() => {
        if (feedback.sendingAppFeedbackSuccess) {
            dispatch(resetSendingAppFeedback());
            resetForm();
            swal.fire({
                type: 'success',
                title: 'Thank you',
                text: 'We will get back to you as soon as possible',
                confirmButtonText: 'Ok',
            });
        }
    }, [feedback.sendingAppFeedbackSuccess, dispatch]);

    useEffect(() => {
        if (feedback.sendingContactRequestSuccess) {
            dispatch(resetSendingContactRequest());
            resetForm();
            swal.fire({
                type: 'success',
                title: 'Thank you',
                text: 'We will get back to you as soon as possible',
                confirmButtonText: 'Ok',
            });
        }
    }, [feedback.sendingContactRequestSuccess, dispatch]);

    useEffect(() => {
        if (authenticated && userName && email) {
            set_formEmail(email);
            set_name(userName);
            set_disabled(true);
        }
    }, [email, authenticated, userName]);

    useEffect(() => {
        if (type === typeDisp) return;

        const changeTextOpacity = (fraction) => {
            let fraction_adj;
            if (fraction < 0.5) fraction_adj = fraction * 2;
            else fraction_adj = 1 - (fraction - 0.5) * 2;

            set_textOpacity(1 - fraction_adj);
            if (fraction > 0.5 && typeDisp !== type) set_typeDisp(type);
        };
        animate({
            timing: (t) => t,
            draw: changeTextOpacity,
            duration: 250,
        });
    }, [type, typeDisp]);

    return (
        <div>
            {typeDisp === 'contact' ? (
                <p className='form-title' style={{ opacity: textOpacity }}>
                    Any question? Please type it below
                </p>
            ) : (
                <p className='form-title' style={{ opacity: textOpacity }}>
                    We value your feedback
                </p>
            )}

            <Grid container direction='column'>
                <TextField variant='outlined' label='Subject' value={subject} onChange={(e) => set_subject(e.target.value)} id='subject' />

                <TextField
                    className='form__field'
                    variant='outlined'
                    label='Full Name'
                    value={name}
                    disabled={disabled}
                    onChange={(e) => set_name(e.target.value)}
                    id='full-name'
                />

                <TextField
                    className='form__field'
                    variant='outlined'
                    label='Email'
                    value={formEmail}
                    disabled={disabled}
                    onChange={(e) => set_formEmail(e.target.value)}
                    id={`Email:${formEmail}`}
                />

                <TextField className='form__field' variant='outlined' rows={4} label='Message' value={message} onChange={(e) => set_message(e.target.value)} />

                <Grid item>
                    <Button
                        className='form__field--button'
                        onClick={handleSubmit}
                        variant='outlined'
                        color='primary'
                        disabled={feedback.sendingAppFeedback || feedback.sendingContactRequest || !subject || !name || !formEmail || !message}
                    >
                        {feedback.sendingAppFeedback || feedback.sendingContactRequest ? 'Sending' : 'Submit'}
                    </Button>
                </Grid>
            </Grid>
        </div>
    );
};

export default Form;
